module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp12_3016.9216159f.png";